export const LUPA_SECTIONS = {
  1: {
    tunniste: "tutkinnotjakoulutukset",
    headingNumber: 1
  },
  2: {
    tunniste: "opetusjatutkintokieli",
    headingNumber: 2
  },
  3: {
    tunniste: "toimintaalue",
    headingNumber: 3
  },
  4: {
    tunniste: "opiskelijavuodet",
    headingNumber: 4
  },
  5: {
    tunniste: "muut",
    headingNumber: 5
  }
};

export const KIELET_SECTIONS = {
  OPETUSKIELET: "Opetuskielet",
  TUTKINTOKIELET: "Tutkintokielet"
};

export const KOHTEET = {
  TUTKINNOT: "tutkinnotjakoulutukset",
  KIELI: "opetusjatutkintokieli",
  TOIMIALUE: "toimintaalue",
  OPISKELIJAVUODET: "opiskelijavuodet",
  MUUT: "muut"
};

export const KOODISTOT = {
  KOULUTUS: "koulutus",
  OIVA_TYOVOIMAKOULUTUS: "oivatyovoimakoulutus",
  TEHTAVAAN_VALMISTAVA_KOULUTUS: "tehtavaanvalmistavakoulutus",
  AMMATILLISEEN_TEHTAVAAN_VALMISTAVA_KOULUTUS:
    "ammatilliseentehtavaanvalmistavakoulutus",
  KULJETTAJAKOULUTUS: "kuljettajakoulutus",
  KIELI: "kieli",
  OSAAMISALA: "osaamisala",
  OPPILAITOKSENOPETUSKIELI: "oppilaitoksenopetuskieli",
  OIVA_MUUT: "oivamuutoikeudetvelvollisuudetehdotjatehtavat"
};

export const LUPA_VOIMASSAOLO_20181231_ASTI = [
  "384301",
  "354301",
  "364308",
  "324101",
  "334117",
  "354401",
  "364304",
  "334115",
  "364201",
  "364901",
  "354111",
  "384101",
  "354201",
  "354212",
  "355411",
  "374117",
  "324130",
  "334118",
  "374123",
  "355502",
  "354409",
  "354103",
  "354104",
  "354801",
  "354403",
  "374124",
  "324107",
  "354602",
  "354115",
  "354205",
  "324128",
  "354114",
  "354605",
  "354605",
  "324109",
  "374118",
  "354802",
  "355410",
  "354116",
  "354702",
  "384204",
  "354106",
  "324110",
  "354404",
  "354803",
  "354311",
  "334104",
  "384111",
  "364109",
  "364301",
  "364301",
  "364305",
  "364302",
  "355905",
  "354603",
  "334105",
  "355402",
  "354206",
  "374121",
  "374114",
  "374114",
  "354207",
  "354710",
  "354710",
  "354107",
  "355903",
  "384109",
  "324115",
  "324116",
  "354705",
  "364106",
  "324119",
  "334106",
  "324129",
  "324120",
  "384108",
  "354405",
  "354407",
  "334114",
  "384106",
  "354209",
  "324126",
  "384113",
  "354804",
  "354211",
  "364102",
  "355407",
  "355906",
  "354112",
  "334102",
  "355413",
  "384205",
  "354109",
  "354709",
  "355212",
  "364202",
  "364205",
  "364107",
  "364204",
  "334111",
  "374113",
  "355902",
  "427101",
  "437108",
  "457301",
  "457302",
  "457401",
  "457304",
  "487101",
  "467201",
  "467904",
  "457101",
  "487304",
  "457201",
  "458410",
  "427130",
  "437101",
  "487303",
  "437102",
  "458502",
  "457102",
  "457103",
  "458503",
  "477106",
  "427107",
  "457109",
  "457207",
  "427128",
  "457111",
  "427109",
  "487401",
  "457803",
  "458408",
  "457702",
  "457104",
  "457303",
  "487201",
  "457105",
  "457802",
  "467102",
  "437110",
  "467302",
  "457603",
  "458409",
  "457205",
  "457801",
  "457206",
  "457709",
  "467304",
  "458204",
  "457110",
  "458207",
  "427114",
  "427115",
  "437104",
  "457705",
  "427118",
  "427119",
  "457404",
  "437109",
  "467101",
  "458901",
  "458411",
  "487106",
  "458405",
  "457106",
  "437106",
  "458412",
  "457108",
  "457306",
  "457708",
  "437111",
  "467203",
  "477107",
  "437107",
  "334109"
];

export const LUPA_VOIMASSAOLO_20180731_ASTI = [
  "354315",
  "354302",
  "354307",
  "334101",
  "355505",
  "355104",
  "364904",
  "354312",
  "364401",
  "364402",
  "364403",
  "354202",
  "355101",
  "355108",
  "355102",
  "355103",
  "355110",
  "355106",
  "364906",
  "355107",
  "355109",
  "354309",
  "354310",
  "354314",
  "384203",
  "355901",
  "354406",
  "324301",
  "334108",
  "364203",
  "354408",
  "457305",
  "457203",
  "477108",
  "458101",
  "458102",
  "467901",
  "467301",
  "477109",
  "467902",
  "457403",
  "477110",
  "427301",
  "457406",
  "381303",
  "381112",
  "381304",
  "351106",
  "381113",
  "321301",
  "321101",
  "381204",
  "352902",
  "381201",
  "351701",
  "352401",
  "351704",
  "321901",
  "351204",
  "321603"
];

export const LUPA_VOIMASSAOLO_20180801_LUKIEN = [
  "355146",
  "354345",
  "355145",
  "364946",
  "364445",
  "354446",
  "384247",
  "457441",
  "477143",
  "458141",
  "467942",
  "381142",
  "321141",
  "381141",
  "381241",
  "351741",
  "352441",
  "381342",
  "321604"
];

export const LUPA_VOIMASSAOLO_20190101_LUKIEN = [
  "354645",
  "364245",
  "324146",
  "334145",
  "354445",
  "364345",
  "354146",
  "384146",
  "354245",
  "355445",
  "374147",
  "355645",
  "354845",
  "384246",
  "354745",
  "384248",
  "364146",
  "384148",
  "384147",
  "437141",
  "355945",
  "427141",
  "457341",
  "457442",
  "484147",
  "467241",
  "458641",
  "487341",
  "457241",
  "458441",
  "437142",
  "457141",
  "487241",
  "437143",
  "457841",
  "457741",
  "487244",
  "467141",
  "467342",
  "484446",
  "458241",
  "467441"
];

export const LUPA_LISAKOULUTTAJAT = {
  "0763403-0": {
    nimi: "ABB Oy",
    diaarinumero: "38/530/2007",
    pvm: "2007-02-21",
    pdflink: "ABB.pdf"
  },
  "0986820-1": {
    nimi: "Cargotec Finland Oy",
    diaarinumero: "1/530/2007",
    pvm: "2007-01-09",
    pdflink: "Cargotec.pdf"
  },
  "0108023-3": {
    nimi: "Finnair Oyj",
    diaarinumero: "551/530/2006",
    pvm: "2006-12-13",
    pdflink: "Finnair.pdf"
  },
  "0188756-3": {
    nimi: "Kainuun Opisto Oy",
    diaarinumero: "289/530/2006",
    pvm: "2006-05-12",
    pdflink: "Kainuun_Opisto.pdf"
  },
  "0950895-1": {
    nimi: "Konecranes Finland Oy",
    diaarinumero: "3/531/2014",
    pvm: "2014-04-22",
    pdflink: "Konecranes.pdf"
  },
  "0206976-5": {
    nimi: "Kymenlaakson Opiston Kannatusyhdistys ry",
    diaarinumero: "190/531/2012",
    pvm: "2012-11-9",
    pdflink: "Kymenlaakson_Opisto.pdf"
  },
  "0151534-8": {
    nimi: "Nanso Group Oy",
    diaarinumero: "57/530/2007",
    pvm: "2007-02-22",
    pdflink: "Nanso.pdf"
  },
  "0112038-9": {
    nimi: "Nokia Oyj",
    diaarinumero: "560/530/2006",
    pvm: "2006-12-13",
    pdflink: "Nokia.pdf"
  },
  "0201789-3": {
    nimi: "Opintotoiminnan Keskusliitto ry, Centralförbundet för Studieverksamhet rf",
    diaarinumero: "178/530/2006",
    pvm: "2006-05-08",
    pdflink: "Opintotoimikunnan_Keskusliitto.pdf"
  },
  "0210311-8": {
    nimi: "Reisjärven Kristillinen Kansanopistoyhdistys ry",
    diaarinumero: "197/531/2012",
    pvm: "2012-11-09",
    pdflink: "Reisjarven_Kristillinen_Kansanopisto.pdf"
  },
  "1524361-1": {
    nimi: "Sanoma Oyj",
    diaarinumero: "3/530/2007",
    pvm: "2007-01-09",
    pdflink: "Sanoma.pdf"
  },
  "1099221-8": {
    nimi: "Tampereen Urheiluhierojakoulu Oy",
    diaarinumero: "238/530/2008",
    pvm: "2010-10-14",
    pdflink: "Tampereen_Urheiluhierojakoulu.pdf"
  },
  "0215382-8": {
    nimi: "Työväen Sivistysliitto TSL ry",
    diaarinumero: "81/531/2011",
    pvm: "2011-12-22",
    pdflink: "Tyovaen_Sivistysliitto_TSL.pdf"
  },
  "1041090-0": {
    nimi: "UPM-Kymmene Oyj",
    diaarinumero: "574/530/2006",
    pvm: "2006-12-13",
    pdflink: "UPM-Kymmene.pdf"
  },
  "0195032-3": {
    nimi: "Vuolle Setlementti ry",
    diaarinumero: "192/531/2012",
    pvm: "2012-11-09",
    pdflink: "Vuolle_Setlementti.pdf"
  },
  "0773744-3": {
    nimi: "Wärtsilä Finland Oy",
    diaarinumero: "563/530/2006",
    pvm: "2006-12-13",
    pdflink: "Wartsila.pdf"
  }
};
